(function(){
  function placePremiumProductNotes(){
    var details=document.querySelector('.product-details > .group-block');
    if(!details)return;
    var note=document.querySelector('[data-ibs-product-note]');
    if(note){
      var variantPicker=details.querySelector('variant-picker');
      if(variantPicker)details.insertBefore(note,variantPicker);else details.appendChild(note);
      note.classList.add('is-ready');
    }
    var assurance=document.querySelector('[data-ibs-product-assurance]');
    if(assurance){
      var buyButtons=details.querySelector('.buy-buttons-block');
      if(buyButtons)buyButtons.insertAdjacentElement('afterend',assurance);else details.appendChild(assurance);
      assurance.classList.add('is-ready');
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',placePremiumProductNotes,{once:true});else placePremiumProductNotes();
})();
